import _Object$assign from '/app/node_modules/babel-runtime/core-js/object/assign';
import { filterEmailDomain } from '~/filters/email-domains';

export default {
  name: 'email-autocomplete',
  data: function data() {
    return {
      domains: [],
      visible: false,
      isComplete: false
    };
  },

  methods: {
    createContent: function createContent() {
      return [this.createTextField(), this.createSuggestionContainer()];
    },
    createTextField: function createTextField() {
      var _this = this;

      var listeners = _Object$assign({}, this.$listeners);
      return this.$createElement('v-text-field', {
        attrs: this.$attrs,
        props: this.$vnode.data.props,
        style: {
          height: this.$attrs.stepper === true ? 'auto !important' : '',
          marginTop: this.$attrs.stepper === true ? '0' : ''
        },
        on: _Object$assign(listeners, {
          input: this.onInput,
          keydown: function keydown(evt) {
            if (evt.keyCode === 9 || evt.keyCode === 27) _this.suggestionHidden();
          }
        }),
        ref: 'input'
      });
    },
    createSuggestionContainer: function createSuggestionContainer() {
      return this.$createElement('div', {
        class: ['v-email-suggestion'],
        style: {
          display: this.visible ? '' : 'none',
          top: this.$attrs.withErrors === true ? '40px' : ''
        }
      }, [this.createSuggestionItems()]);
    },
    createSuggestionItems: function createSuggestionItems() {
      var _this2 = this;

      if (this.domains && this.domains.length) {
        return this.domains.map(function (item, index) {
          return _this2.$createElement('div', {
            class: ['v-suggestion-item'],
            on: {
              click: function click(evt) {
                evt.preventDefault();
                _this2.suggestionComplete(index);
              }
            }
          }, item);
        });
      } else return;
    },
    onInput: function onInput(val) {
      var indexOfSymbol = val.indexOf('@');
      indexOfSymbol === -1 ? this.isComplete = false : this.isComplete = true;
      if (indexOfSymbol > -1 && val.length > indexOfSymbol + 1) {
        var stringToCompare = val.slice(indexOfSymbol + 1, val.length);
        var lastIndexOfPoint = stringToCompare.lastIndexOf('.') === -1;
        lastIndexOfPoint === true ? this.isComplete = false : this.isComplete = true;
        if (this.isComplete === false) {
          this.visible = true;
          this.domains = filterEmailDomain(stringToCompare);
        }
      } else this.suggestionHidden();
      this.$emit('input', val);
    },
    isClickOutsite: function isClickOutsite(evt) {
      if (this.visible === true && this.$el.contains(evt.target) === false) this.suggestionHidden();
    },
    suggestionHidden: function suggestionHidden() {
      this.domains = [];
      this.visible = false;
      this.isComplete = true;
    },
    suggestionComplete: function suggestionComplete(index) {
      var indexOfSymbol = this.$refs.input.$data.lazyValue.indexOf('@');
      var domainToComplete = this.domains[index];
      var emailWithOutDomain = this.$refs.input.$data.lazyValue.slice(0, indexOfSymbol);
      this.$refs.input.$data.lazyValue = emailWithOutDomain + '@' + domainToComplete;
      this.onInput(this.$refs.input.$data.lazyValue);
      this.suggestionHidden();
    }
  },
  mounted: function mounted() {
    if (this.$options.parent && this.$options.parent.$el) {
      this.$options.parent.$el.addEventListener('click', this.isClickOutsite.bind(this));
    }
  },
  destroy: function destroy() {
    if (this.$options.parent && this.$options.parent.$el) {
      this.$options.parent.$el.removeEventListener('click', this.isClickOutsite.bind(this));
    }
  },
  render: function render(createElement) {
    return createElement('div', {
      class: ['v-email-autocomplete'],
      style: {}
    }, this.createContent());
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/inputs/email-autocomplete.js
// module id = ./src/components/shared/inputs/email-autocomplete.js
// module chunks = 34